<div class="wrapper-mini text-center auth-form">
    <h1 class="header">Sign Up</h1>
    <p class="margin-bottom-20">Enter your email address to get started</p>

    <div class="form-block text-left">
        <label for="email">Email</label>
        <input type="email" name="email" data-testid="input-signup-email" [(ngModel)]="email" (keyup.enter)="checkEmail()" required>
    </div>

    <div class="footer">
        <saffron-button text="Continue"
                        data-testid="btn-signup-continue"
                        size="wide" 
                        type="primary" 
                        [is_loading]="loading"
                        [is_disabled]="!email"
                        (click)="checkEmail()">
        </saffron-button>
        <p>
            Already have an account?
            <a class="text-color-primary" data-testid="link-login" [routerLink]="['/auth/login']">Login</a>
        </p>
    </div>
</div>
